import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Satellites from "./Pages/Satellites/Satellites";
import Cybersecurity from "./Pages/Cybersecurity/Cybersecurity";
import Networks from "./Pages/Networks/Networks";
import Surveillance from "./Pages/Surveillance/Surveillance";
import PowerSolutions from "./Pages/PowerSolutions/PowerSolutions";
import Professionalservices from "./Pages/Professional services/Professional services";
import ContactUs from "./Pages/ContactUs/ContactUs";
import Career from "./Pages/Career/Career";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import MobMenu from "./Components/MobMenu/MobMenu";
import PreReleaseWraper from "./Modules/PressReleases/Pages/PressReleaseWraper";
import BoardChairman from "./Modules/LeaderShip/Pages/BoardChairman";
import LeasderShipWraper from "./Modules/LeaderShip/Pages/LeasderShipWraper";
import ImranFarooq from "./Modules/LeaderShip/Pages/ImranFarooqCTO";
import AliCEO from "./Modules/LeaderShip/Pages/AliCEO";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import CareerOpenings from "./Pages/CareerOpenings/CareerOpenings";
import AamirHeadBu from "./Modules/LeaderShip/Pages/AamirHeadBu";
import TerraMonitor from "./Pages/IotPages/TerraMonitor";
import Umeter from "./Pages/IotPages/Umeter";
import Dynalock from "./Pages/IotPages/Dynalock";
import DynaTrace from "./Pages/IotPages/DynaTrace";
import CitySense from "./Pages/IotPages/CitySense";
import Dynafleet from "./Pages/IotPages/Dynafleet";
import EcoClean from "./Pages/IotPages/EcoClean";
import InteliPark from "./Pages/IotPages/InteliPark";
import SmartSentry from "./Pages/IotPages/SmartSentry";
import NewLanding from "./Pages/Landing/NewLanding";
import IotLanding from "./Pages/IotPages/IotLanding";
import SatelliteCommunications from "./Pages/SatelliteComPages/SatelliteCommunications";
import Flyaway from "./Pages/SatelliteComPages/Flyaway";
import SatcomAntenna from "./Pages/SatelliteComPages/SatcomAntenna ";
import SatcomFlyaway from "./Pages/SatelliteComPages/SatcomFlyaway";
// import ScreenSize from "./Components/ScreenSize/ScreenSize";
import { GlobalProvider } from "./Components/GlobalContext/GlobalContext";
import Partners from "./Pages/Partners/Partners";
import UzairHeadOfProducts_Iot from "./Modules/LeaderShip/Pages/UzairHeadOfProducts_Iot";
import PressReleasePage from "./Modules/PressReleases/Pages/PressReleasePage";

function App() {
  return (
    <div className="App">
      <GlobalProvider>
        <BrowserRouter>
          {/*  <ScreenSize /> */}
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<NewLanding />} />
            <Route path="/whoweare" element={<AboutUs />} />
            {/* <Route path="/iot" element={<IotNew />} /> */}
            <Route path="/satellites" element={<Satellites />} />
            <Route path="/cybersecurity" element={<Cybersecurity />} />
            <Route path="/networks" element={<Networks />} />
            <Route path="/surveillance" element={<Surveillance />} />
            <Route path="/powersolutions" element={<PowerSolutions />} />
            <Route
              path="/professionalservices"
              element={<Professionalservices />}
            />

            {/* Our News Routes */}
            <Route path="/our_news" element={<PreReleaseWraper />} />
            {/* <Route
              path="/our_news/hamid_nawaz_press_release"
              element={<HamidNawazPressRelease />}
            />
            <Route
              path="/hamid_nawaz_press_release"
              element={<HamidNawazPressRelease />}
            /> */}

            {/* <Route
              path="/our_news/disrupt_x_press_release"
              element={<DisruptXPressRelease />}
            />
            <Route
              path="/disrupt_x_press_release"
              element={<DisruptXPressRelease />}
            /> */}
            {/* <Route
              path="/imran_farooq_press_release"
              element={<ImranFarooqPressRelease />}
            />
            <Route
              path="/our_news/imran_farooq_press_release"
              element={<ImranFarooqPressRelease />}
            /> */}

            {/* DynaSys Networks receives IoT LPWAN License */}

            {/* <Route path="/iot_license" element={<MousSigningCeremony />} />
            <Route
              path="/our_news/iot_license"
              element={<MousSigningCeremony />}
            /> */}

            {/* PTCL & DynaSys Networks Join Hands */}

            {/* <Route path="/ptcl_dynasys" element={<PtclDynasysJoinHands />} />
            <Route
              path="/our_news/ptcl_dynasys"
              element={<PtclDynasysJoinHands />}
            /> */}

            {/* DynaSys Networks and Xiplink Awarded Cellular Backhaul Optimization Project in Central Asia */}
            {/* <Route path="/dynasys_xiplink" element={<DynasysXiplink />} />
            <Route
              path="/our_news/dynasys_xiplink"
              element={<DynasysXiplink />}
            /> */}

            {/* Inotech & DynaSys Combine Forces to Commercialize IoT in Pakistan */}

            {/* <Route
              path="/inotech_dynasys"
              element={<InotechAndDynasysCombine />}
            />
            <Route
              path="/our_news/inotech_dynasys"
              element={<InotechAndDynasysCombine />}
            /> */}

            {/* IoT Innovation in Pakistan Accelerated – DynaSys and Pronet ink MoU */}

            {/* <Route
              path="/dynasys_pronet_ink_mou"
              element={<DynasysPronetInk />}
            />
            <Route
              path="/our_news/dynasys_pronet_ink_mou"
              element={<DynasysPronetInk />}
            /> */}

            {/* // DynaSys and TSGN Join Forces to Accelerate IoT Growth.. */}

            {/* <Route
              path="/dynasys_tsgn_join_forces"
              element={<DynasysTsgnJoinForces />}
            />
            <Route
              path="/our_news/dynasys_tsgn_join_forces"
              element={<DynasysTsgnJoinForces />}
            /> */}

            {/*     // Azercosmos to Offer IoT Solutions Across Its Satcom Network.. */}

            {/* <Route
              path="/azercosmos_offer_iot_solution"
              element={<AzercosmosOfferIotSolution />}
            />
            <Route
              path="/our_news/azercosmos_offer_iot_solution"
              element={<AzercosmosOfferIotSolution />}
            /> */}

            {/* DynaSys Triumphs Twice at HBL P@SHA ICT Awards 2024 */}

            {/* <Route
              path="/dynasys_triumphs_twice_at_hbl_pasha"
              element={<DynaSysTriumphsTwiceatHBLPasha />}
            />
            <Route
              path="/our_news/dynasys_triumphs_twice_at_hbl_pasha"
              element={<DynaSysTriumphsTwiceatHBLPasha />}
            /> */}

            {/* DynaSys Networks Pioneers Pakistan's IoT Future */}

            {/* <Route
              path="/dynasys_networks_pioneers_pakistan's_iot_future"
              element={<DynaSysNetworksPioneersPakistan />}
            />
            <Route
              path="/our_news/dynasys_networks_pioneers_pakistan's_iot_future"
              element={<DynaSysNetworksPioneersPakistan />}
            /> */}

            {/* DynaSys Networks and PakSat International Pioneer.. */}

            {/* <Route
              path="/dynasys_networks_and_paksat_international_pioneer"
              element={<DynasysPaksatInternationalPioneer />}
            />
            <Route
              path="/our_news/dynasys_networks_and_paksat_international_pioneer"
              element={<DynasysPaksatInternationalPioneer />}
            /> */}

            {/* DynaSys Networks AT APICTA AWARDS.. */}

            {/* <Route
              path="/dynasys_networks_at_apicta_awards"
              element={<DynasysApictaAwards />}
            />
            <Route
              path="/our_news/dynasys_networks_at_apicta_awards"
              element={<DynasysApictaAwards />}
            /> */}

            {/* Aamir Bashir Joins DynaSys */}

            {/* <Route
              path="/aamir_bashir_joins_dynasys"
              element={<AamirBashirJoinsDynaSys />}
            />
            <Route
              path="/our_news/aamir_bashir_joins_dynasys"
              element={<AamirBashirJoinsDynaSys />}
            /> */}

            {/* Azercosmos Activates First IoT Solution */}

            {/* <Route
              path="/azercosmos_activates_first_iot_solution"
              element={<AzercosmosActivatesFirstIoTSolution />}
            />
            <Route
              path="/our_news/azercosmos_activates_first_iot_solution"
              element={<AzercosmosActivatesFirstIoTSolution />}
            /> */}

            {/* Jazz Partners with DynaSys to Accelerate IoT-Driven Innovation in Pakistan */}

            {/* <Route
              path="/jazz_partners_with_dynaSys_to_accelerate_iot_Driven_innovation_in_pakistan"
              element={<JazzPartnersDynaSysAccelerate />}
            />
            <Route
              path="/our_news/jazz_partners_with_dynaSys_to_accelerate_iot_Driven_innovation_in_pakistan"
              element={<JazzPartnersDynaSysAccelerate />}
            /> */}

            {/*  DynaSys Networks Signs Strategic MoU with APPLIOT GLOBAL to Accelerate Global IoT Expansion */}

            {/* <Route
              path="/dynaSys_networks_signs_strategic_mou"
              element={<DynaSysNetworksSignsStrategicMoU />}
            />
            <Route
              path="/our_news/dynaSys_networks_signs_strategic_mou"
              element={<DynaSysNetworksSignsStrategicMoU />}
            /> */}

            {/*  A Major IoT Partnership Emerges in Pakistan Milesight and DynaSys Networks Join Hands to Drive IoT Innovation */}

            {/* <Route
              path="/pakistan_milesight_and_dynaSys_networks_join_hands"
              element={<PakistanMilesightDynaSysNetworks />}
            />
            <Route
              path="/our_news/pakistan_milesight_and_dynaSys_networks_join_hands"
              element={<PakistanMilesightDynaSysNetworks />}
            /> */}

            {/*  WeatherWalay and DynaSys Networks Partner to Leverage IoT for Climate Monitoring and Disaster Management */}

            {/* <Route
              path="/weatherwalay_and_dynasys_networks_partner_to_leverage_iot_for_climate"
              element={<WeatherWalayDynaSysNetworksPartner />}
            />
            <Route
              path="/our_news/weatherwalay_and_dynasys_networks_partner_to_leverage_iot_for_climate"
              element={<WeatherWalayDynaSysNetworksPartner />}
            /> */}

            {/*  DynaSys and Jazz Launch First City-Wide LoRaWAN Network in Lahore, Pioneering Pakistan's Digital Future */}

            {/* <Route
            path="/dynaSys_jazz_launch_first_city_wide_lorawan_network"
            element={<DynaSysJazzLaunchFirstCityWideLoRaWANNetwork />}
          />
          <Route
            path="/our_news/dynaSys_jazz_launch_first_city_wide_lorawan_network"
            element={<DynaSysJazzLaunchFirstCityWideLoRaWANNetwork />}
          /> */}

            {/* <Route
              path="/muhammad_uzair_akhtar_appointed_head_of_products_iot_at_dynasys_networks"
              element={<MuhammadUzairAkhtarAppointedHeadProducts />}
            />
            <Route
              path="/our_news/muhammad_uzair_akhtar_appointed_head_of_products_iot_at_dynasys_networks"
              element={<MuhammadUzairAkhtarAppointedHeadProducts />}
            /> */}

            {/*  NADRA Technologies Joins Forces with DynaSys to Accelerate IoT Adoption in Pakistan */}

            {/* <Route
              path="/nadra_technologies_joins_forces_with_dynasys"
              element={<NadraTechnologiesJoinsForcesDynaSys />}
            />
            <Route
              path="/our_news/nadra_technologies_joins_forces_with_dynasys"
              element={<NadraTechnologiesJoinsForcesDynaSys />}
            /> */}

            {/*  Disrupt-X and DynaSys Join Hands to Develop Infrastructure in Pakistan to Support 40 Million Smart Water Meters */}

            {/* <Route
              path="/disrupt_x_and_dynasys_join_hands"
              element={<DisruptXDynaSysJoinHandsDevelop />}
            />
            <Route
              path="/our_news/disrupt_x_and_dynasys_join_hands"
              element={<DisruptXDynaSysJoinHandsDevelop />}
            /> */}

            {/*  DynaSys Networks Bags 4 Awards at HBL P@SHA ICT Awards 2025 */}

            {/* <Route
              path="/dynasys_networks_awards_hbl_pasha_awards_2025"
              element={<DynasysAndPashaICTAwards />}
            />
            <Route
              path="/our_news/dynasys_networks_awards_hbl_pasha_awards_2025"
              element={<DynasysAndPashaICTAwards />}
            /> */}

            {/*  DynaSys Networks Bags 4 Awards at HBL P@SHA ICT Awards 2025 */}

            {/* <Route
              path="/dynasys_plan_s_partner_to_bring_satellite_powered"
              element={<DynasysPlanSPartner />}
            />
            <Route
              path="/our_news/dynasys_plan_s_partner_to_bring_satellite_powered"
              element={<DynasysPlanSPartner />}
            /> */}

            {/*  Disrupt-X, Intel, and DynaSys Networks Collaborate to Drive Digital Transformation for Critical Infrastructure ... */}

            {/* <Route
              path="/disrupt-x-intel-and-dynasys-networks-collaborate-to-drive-digital-transformation-for-critical-infrastructure"
              element={<DisruptXDynasysCollaborate />}
            />
            <Route
              path="/our_news/disrupt-x-intel-and-dynasys-networks-collaborate-to-drive-digital-transformation-for-critical-infrastructure"
              element={<DisruptXDynasysCollaborate />}
            /> */}

            {/*  Jazz & DynaSys Ignite Pakistan’s First Smart City Revolution with LoRaWAN Network Enablement*/}

            {/* <Route
              path="/jazz-and-dynasys-ignite-pakistan-first-smart-city-revolution-with-lorawan-network-enablement"
              element={<JazzDynasysIgnitePakistan />}
            />
            <Route
              path="/our_news/jazz-and-dynasys-ignite-pakistan-first-smart-city-revolution-with-lorawan-network-enablement"
              element={<JazzDynasysIgnitePakistan />}
            /> */}

            {/* PRESS RELEASES DYNAMIC ROUTES  */}
            <Route path="/our_news/:id" element={<PressReleasePage />} />
            <Route path="/:id" element={<PressReleasePage />} />

            {/* LeaderShip routes */}
            <Route path="/leadership" element={<LeasderShipWraper />} />
            <Route path="/founder&ceo" element={<AliCEO />} />
            {/* <Route path="/board_chairman" element={<BoardChairman />} /> */}
            <Route path="/chief_technology_officer" element={<ImranFarooq />} />
            {/* <Route path="/head_of_bu" element={<AamirHeadBu />} /> */}
            <Route
              path="/head _of_products_iot"
              element={<UzairHeadOfProducts_Iot />}
            />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/careers" element={<Career />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/available_positions" element={<CareerOpenings />} />
            <Route path="/mobmenu" element={<MobMenu />} />
            {/* <Route path="/videowhite" element={<LandingVideo />} /> */}
            {/* <Route path="/videoblack" element={<LandingVideoblack />} /> */}

            {/* IOT PAGES ROUTES  */}
            <Route path="/iot" element={<IotLanding />} />
            <Route path="/teramonitor" element={<TerraMonitor />} />
            <Route path="/umeter" element={<Umeter />} />
            <Route path="/dynalock" element={<Dynalock />} />
            <Route path="/dynatrace" element={<DynaTrace />} />
            <Route path="/citysense" element={<CitySense />} />
            <Route path="/dynafleet" element={<Dynafleet />} />
            <Route path="/ecoclean" element={<EcoClean />} />
            <Route path="/intelipark" element={<InteliPark />} />
            <Route path="/smartsentry" element={<SmartSentry />} />

            {/* SATELLITE COMMUNICATIONS PAGES ROUTES  */}
            <Route
              path="/satellite_communications"
              element={<SatelliteCommunications />}
            />
            <Route path="/0.9m_flyaway_ku_band" element={<Flyaway />} />
            <Route path="/1.2m_fixed_ku_band" element={<SatcomAntenna />} />
            <Route path="/1.2m_flyaway_ku_band" element={<SatcomFlyaway />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </GlobalProvider>
    </div>
  );
}

export default App;
